/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ViewResignationAttachments from "./ResignationAttachment";
import Breadcrumbs from "components/Breadcrumbs";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { approveResginationApi, createResginationApi, getResignationDetailApi } from "api/services/resignations";
import { useResignation } from "../context/resignationContext";
import AllResignationAddPopup from "../../../../components/modelpopup/AllResignationAddPopup";
import {formatDateHandler2} from "utils/common"
import './styles.css';
import { useSelector } from "react-redux";
import { toast, Bounce } from "react-toastify";


const ResignationDetail = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const params = useParams();
  const {
    loading,
    resignationData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    handleResignationDetailPage,
    selectedPage,
    resignationModal,
    setSelectedResignation,
    setResignationModal,
    selectedResignation,
    setLoading
  } = useResignation();


  const [userData, setUserData] = useState({});
  const [approvalComments, setApprovalComments] = useState("")

  const [resignationDetailData, setResignationDetailData] = useState([]) 
  const {
    user, userLoading   
} = useSelector((state) => state.user);

  useEffect(() => {
    console.log("regisn details-----", params?.id)
    getResignationData()
  }, [params?.id]);


  const getResignationData = () => {
    if (params?.id) {
      getResignationDetailApi(params?.id).then((response) => {
        console.log(response, "REEEEEEE");
        setUserData(response.data);   
      
        const resignationDetailData =  [
          { id: 1, title: "Employee Name", text:response.data?.company_user?.first_name + " "+response.data?.company_user?.last_name},          
          { id: 3, title: "Emp No.", text:response.data?.company_user?.emp_no},
          { id: 4, title: "Designation", text:response.data?.company_user?.position_name},
          { id: 4, title: "Email", text:response.data?.company_user?.email},         
          { id: 6, title: "Last Working Day", text: formatDateHandler2(response.data?.last_working_day) },
          { id: 7, title: "Reason", text: response.data?.reason},  
          { id: 5, title: "Current Approver", text:response.data?.current_approver?.first_name + " "+response.data?.current_approver?.last_name},
          { id: 8, title: "Approval Status", text:   <span className={`badge badge-soft-${ response.data?.approval_status == "pending" ?  "warning" : response.data?.approval_status == "rejected" ? "danger" : "success"}`}>{response.data?.approval_status}</span>  },  
       //   { id: 8, title: "Approved On", text:  formatDateHandler2(response.data?.approved_on)} ,  
        ]
       
          if (response.data?.approval_status === "approved") {
            resignationDetailData.push({
              id: 9,
              title: "Approved On",
              text: formatDateHandler2(response.data?.approved_on),
            });
          }
        setResignationDetailData(resignationDetailData) 

      });
    }
  }
  const handleClickGoBack = () => {
    navigate(-1);
  };

  const handleClickNext = () => {
    const nextIndex = selectedPage + 1;
    if (nextIndex < pageSettings.total) {
      let nextEmployee = resignationData[nextIndex];
      handleResignationDetailPage(nextEmployee.id, nextIndex);
    }
  };

  const handleClickPrevious = () => {
    const prevIndex = selectedPage - 1;
    if (prevIndex >= 0) {
      let nextEmployee = resignationData[prevIndex];
      handleResignationDetailPage(nextEmployee.id, prevIndex);
    }
  };

  const reloadPage = () => {
    getResignationData()
  }


  const handleApprove = () => {
    let data = {}
    data["action"] = "approve";
    data["comment"] = approvalComments;
    data["company_user"] = userData.company_user?.id;
    console.log(data, "------data");


    approveResginationApi(userData.company_user?.id, data).then(response=>{
      setLoading(false)

      toast.success('Approved successfully!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        navigate("/resignations")
      console.log(response, "REEEEEE")
    }).catch(e=> {
      setLoading(false)

      try{
        console.log(e.response.data, "EEEEE")
        if(e.response.data){
          Object.entries(e.response.data).forEach(([k, v]) => {
            console.log(typeof v, "EEEEE")
       
          })
          let commonError = e.response?.data?.error || 'Failed to approve resignation!'
          toast.error(commonError, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
            });
        }
      }catch(e){
        console.log(e, "----ee")
        let commonError = e.response?.data?.error || 'Failed to approve resignation!'
        toast.error(commonError, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
          });
      }

    })
  }

  const handleCommentsChange = (event) => {
    setApprovalComments(event.target.value);
  };


  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Resignation Detail"
            title="Resignation"
            subtitle="Resignation Details"
            modal="#add_resignation"
            name="Add New"
            showModal={false}
            linkName="/resignations"
          />

          <div className="contact-head">
            <div className="row align-items-center">
              <div className="col-sm-6">
                <ul className="contact-breadcrumb">
                  <li>
                    <Link to="#" onClick={handleClickGoBack}>
                      <i className="las la-arrow-left" /> Resignations
                    </Link>
                  </li>
                  <li>
                    {userData?.company_user?.first_name+ " "+userData?.company_user?.last_name} 
                  </li>
                </ul>
              </div>
              <div className="col-sm-6 text-sm-end">
                <div className="contact-pagination">
                  <p>
                    {selectedPage + 1} of {pageSettings.total}
                  </p>
                  <ul>
                    <li>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickPrevious();
                        }}                       
                      >
                        <i className="las la-arrow-left" />
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={(e) => {
                          e.preventDefault();
                          handleClickNext();
                        }}                      
                      >
                        <i className="las la-arrow-right" />
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="card mb-0">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div className="profile-view">
                    <div className="profile-img-wrap">
                      <div className="profile-img">
                        <Link to="#">
                          <img src={userData?.company_user?.profile_image} alt="Image" />
                        </Link>
                      </div>
                    </div>
                    <div className="profile-basic">
                    
                      <div className="ml-2 mt-3 row">                     
                        <div className="col-md-12">
                        <ul className="personal-info">
                        {resignationDetailData.map((item, index) => (
                          <ListItem
                            id={item.id}
                            key={index}
                            title={item.title}
                            text={item.text}
                          />
                        ))}
                  </ul>
           
                        </div>
                      </div>

                      {user.role?.access_scope !== "self" && user?.emp_no == userData.current_approver?.emp_no && userData.approval_status == "pending" &&
                      <>
                        <div className="ml-2 mt-3 row">    
                       <div className="col-md-6">                           
                          <button class="btn btn-success approve-btn" label="Approve" onClick={handleApprove}>Approve</button>                         
                        </div>
                        </div>
                        <div className="ml-2 mt-3 row">    
                        <div className="col-md-6">
                         <label class="col-form-label ">Comments</label><textarea disabled="" rows="3" class="form-control" value={approvalComments}  onChange={handleCommentsChange}></textarea>
                        </div>
                        </div>
                        </>
                      }
                    </div>
              

                    <AllResignationAddPopup reloadPage={reloadPage} setSelectedResignation={setSelectedResignation} setLoading={setLoading} selectedResignation={selectedResignation} loading={loading}  resignationModal={resignationModal} setResignationModal={setResignationModal} />

                  </div>
                </div>
              </div>
            </div>
          </div>

        
        
        </div>
      </div>
    </>
  );
};

export const ListItem = ({ title, text }) => (
  <li>
    <div className="title">{title}</div>
    <div className="text">{text}</div>
  </li>
);

export default ResignationDetail;
